import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, Typography, useMediaQuery, Slide, AppBar, Toolbar, IconButton, withStyles, CircularProgress, Checkbox, FormControlLabel, TextField as MuiTextField } from '@material-ui/core';
import {
    List, Datagrid, TextField, FunctionField, TextInput, Edit, RadioButtonGroupInput, SimpleForm, BooleanInput, Toolbar as RaToolbar, useInput, SaveButton, useRedirect, useRefresh, SimpleList, ExportButton,
} from 'react-admin';
import { customTheme } from "./customTheme";
import ImageGalleryDialog from "./components/ImageGalleryDialog";
import { Helmet } from "react-helmet";
import CloseIcon from '@material-ui/icons/Close';
import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet";
import RoomIcon from '@material-ui/icons/Room';
import featuresJson from "./features.json";
// import RaCheckBoxInput from './components/RaCheckBoxInput';
import EsperGroupSelector from './components/EsperGroupSelector';
import { TimeInput } from 'react-admin-date-inputs';
import RaLocationInput from './components/RaLocationInput';
import RaImagesInput from './components/RaImagesInput';
import config from "./config.json";
import RefreshIcon from '@material-ui/icons/Refresh';
import Skeleton from '@material-ui/lab/Skeleton';
import moment from "moment";
import CustomSearch from './components/CustomSearch';
import CustomFilter from './components/CustomFilter';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ScrollableTable from './components/ScrollableTable';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
        maxWidth: 1000,
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    parkingListHead: {
        color: "#777",
    },
    errorBackground: {
        backgroundColor: customTheme.palette.error.main,
        color: "#fff",
        '&:hover': {
            backgroundColor: "#be403e",
        }
    },
    errorText: {
        color: customTheme.palette.error.main,
    },
    checkIcon: {
        fontSize: 18,
        color: customTheme.palette.primary.main,
        marginRight: 6,
    },
    crossIcon: {
        fontSize: 18,
        color: customTheme.palette.error.main,
        marginRight: 6,
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    statusCircle: {
        width: 10,
        height: 10,
        marginRight: 8,
        borderRadius: 10,
    },
    summaryTextContainer: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        gap: 10,
        justifyContent: "center"
    }
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function ParkingDetailsList(props) {
    const classes = useStyles();
    //const notify = useNotify();
    const refresh = useRefresh();
    const location = useLocation()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [currentMapCoords, setCurrentMapCoords] = useState(null);
    const [summary, setSummary] = useState(null);
    const [summaryLoading, setSummaryLoading] = useState(false);

    let searchTypeState = ["Parking Name"]
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Parking Name");
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };

    let filterTypesInitState = [
        {
            filterType: "Status",
            dataList: [{ name: "Active", id: 1 }, { name: "Inactive", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]


    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, parking_name: search ? search : undefined };


    const showLocationOnMap = record => {
        setCurrentMapCoords({
            coordinates: [record.parking_latitude, record.parking_longitude],
            label: record.name
        });
    };

    const closeMap = () => {
        setCurrentMapCoords(null);
    };

    const renderCoordinates = record => (
        <Typography variant="body2" color="secondary" className={classes.columnLink} onClick={() => showLocationOnMap(record)}>
            <RoomIcon style={{ fontSize: 20, marginRight: 4 }} />
            {parseFloat(record["parking_latitude"]).toFixed(6)}, {parseFloat(record["parking_longitude"]).toFixed(6)}
        </Typography>
    );

    const renderStatus = record => (
        <div style={{ display: 'flex', alignItems: "center" }}>
            <div className={classes.statusCircle} style={{ backgroundColor: record.approved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main }} />
            {record.approved === 1 ? "Active" : "Inactive"}
        </div>
    );
    const renderStatusForMob = record => (
        <div style={{ display: 'flex', alignItems: "center" }}>
            <span style={{ color: "#5a5a5a", marginRight: 5 }}>Status:</span>
            <div className={classes.statusCircle} style={{ backgroundColor: record.approved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main }} />
            {record.approved === 1 ? "Active" : "Inactive"}
        </div>
    );

    const fetchSummary = () => {
        setSummaryLoading(true);
        fetch(`${config.HOST_NAME}/crm/v3/parkingInfoSummary?user_id=${sessionStorage.getItem("user_id")}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((json) => {
                setSummaryLoading(false);
                if (json.success) {
                    setSummary({ active: json.active, inactive: json.inactive, totalAccessKeys: json.totalAccessKeys });
                } else {
                    notify(json.message, 'warning');
                }
            })
            .catch((e) => {
                setSummaryLoading(false);
                notify('Error Fetching Parking Details Summary', 'warning')
            });
    };

    const refreshSummary = () => {
        refresh();
        fetchSummary();
    };

    useEffect(() => {
        fetchSummary();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Status") {
                    values = { ...values, approved: filterListValue[0].value === "Active" ? 1 : filterListValue[0].value === "Inactive" ? 0 : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    return (<div style={{ marginTop: 20 }}>
        <Helmet>
            <link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css" integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A==" crossorigin="" />
        </Helmet>

        {
            isSmallDevice ?
                <div style={{ display: "flex", padding: "0px 20px", flexWrap: "nowrap", marginBottom: 20 }}>
                    <div style={{ width: "50%" }}>
                        <Typography variant="subtitle1">Active Parkings:</Typography>
                        {summaryLoading ?
                            <Skeleton variant="text" width={25} height={30} />
                            :
                            <Typography variant="subtitle1" color="primary">{summary ? summary.active : 0}</Typography>
                        }
                    </div>
                    <div style={{ width: "50%" }}>
                        <Typography variant="subtitle1">Inactive Parkings:</Typography>
                        {summaryLoading ?
                            <Skeleton variant="text" width={25} height={30} />
                            :
                            <Typography variant="subtitle1" color="error">{summary ? summary.inactive : 0}</Typography>
                        }
                    </div>
                    <div style={{ width: "50%" }} >
                        <Typography variant="subtitle1">Total Access Keys:</Typography>
                        {summaryLoading ?
                            <Skeleton variant="text" width={25} height={30} />
                            :
                            <Typography variant="subtitle1" color="secondary">{summary ? summary.totalAccessKeys : 0}</Typography>
                        }
                    </div>
                    <IconButton onClick={refreshSummary} color="primary" disabled={summaryLoading}>
                        {summaryLoading ?
                            <CircularProgress size={26} />
                            :
                            <RefreshIcon style={{ fontSize: 26 }} />
                        }
                    </IconButton>
                </div>
                :
                <div style={{ display: "flex", justifyContent: "space-between", gap: 30 }}>
                    <div style={{ flex: 1, display: "flex", justifyContent: "space-between" }}>
                        <div className={classes.summaryTextContainer}>
                            <Typography variant="subtitle1">Active Parkings:</Typography>
                            {summaryLoading ?
                                <Skeleton variant="text" width={25} height={30} />
                                :
                                <Typography variant="subtitle1" color="primary">{summary ? summary.active : 0}</Typography>
                            }
                        </div>
                        <div className={classes.summaryTextContainer} style={{ borderLeft: "1px solid #aaa", borderRight: "1px solid #aaa" }}>
                            <Typography variant="subtitle1">Inactive Parkings:</Typography>
                            {summaryLoading ?
                                <Skeleton variant="text" width={25} height={30} />
                                :
                                <Typography variant="subtitle1" color="error">{summary ? summary.inactive : 0}</Typography>
                            }
                        </div>
                        <div className={classes.summaryTextContainer}>
                            <Typography variant="subtitle1">Total Access Keys:</Typography>
                            {summaryLoading ?
                                <Skeleton variant="text" width={25} height={30} />
                                :
                                <Typography variant="subtitle1" color="secondary">{summary ? summary.totalAccessKeys : 0}</Typography>
                            }
                        </div>
                    </div>
                    <IconButton onClick={refreshSummary} color="primary" disabled={summaryLoading}>
                        {summaryLoading ?
                            <CircularProgress size={26} />
                            :
                            <RefreshIcon style={{ fontSize: 26 }} />
                        }
                    </IconButton>
                </div>
        }
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            <ExportButton className='customCreateBtnStyle' label={false} />
        </div>

        <List
            {...props}
            style={{ marginTop: 20 }}
            sort={{ field: "update_time", order: "DESC" }}
            filter={filter}
            actions={false}
            bulkActionButtons={false}
            empty={false}
            pagination={<CustomPagination />}
        >
            {isSmallDevice ?
                <SimpleList

                    primaryText={record => record.name}
                    secondaryText={record => {
                        return (<div>
                            {record.parking_type && <div style={{ color: customTheme.palette.secondary.main }}>{record.parking_type}</div>}
                            {record.parking_address && <div><span style={{ color: "#5a5a5a" }}>Address: </span>{record.parking_address}</div>}
                            {record.access_key_name && <div><span style={{ color: "#5a5a5a" }}>Access Key: </span> <FunctionField label="Access Key" render={record => record.access_key_name} /></div>}
                            {record.assigned_city && <div><span style={{ color: "#5a5a5a" }}>Assigned City: </span> <FunctionField label="Assigned City" render={record => record.assigned_city} /></div>}
                            {record.created_by_name && <div><span style={{ color: "#5a5a5a" }}>Created By: </span>{record.created_by_name}</div>}
                            {record.created_on && <div><span style={{ color: "#5a5a5a" }}>Created On: </span><FunctionField label="Created On" source="created_on" render={record => renderTime(record["created_on"])} /></div>}
                            {record.update_time && <div><span style={{ color: "#5a5a5a" }}>Updated On: </span><FunctionField label="Updated On" source="update_time" render={record => renderTime(record["update_time"])} /></div>}
                            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <FunctionField label="Status" render={renderStatusForMob} />
                                <FunctionField label="Coordinates" render={renderCoordinates} />
                            </div>
                        </div>);
                    }}
                    rightIcon={record => <ImageGalleryDialog {...props} record={record} source="parking_images" />}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid component={ScrollableTable} classes={{ headerCell: classes.parkingListHead }} rowClick="edit">
                    <TextField label="Parking Name" source="name" />
                    <TextField label="Parking Type" source="parking_type" />
                    <FunctionField label="Coordinates" render={record => record && renderCoordinates(record)} />
                    <TextField label="Parking Address" source="parking_address" />
                    <ImageGalleryDialog source="parking_images" />
                    <FunctionField label="Access Key" render={record => record && record.access_key_name ? record.access_key_name : "-"} />
                    <FunctionField label="Assigned City" render={record => record && record.assigned_city ? record.assigned_city : "-"} />
                    <FunctionField label="Status" render={record => record && renderStatus(record)} />
                    <TextField label="Created By" source="created_by_name" />
                    <FunctionField label="Created On" source="created_on" render={record => record && renderTime(record["created_on"])} />
                    <FunctionField label="Updated On" source="update_time" render={record => record && renderTime(record["update_time"])} />
                </Datagrid>
            }
        </List>

        <Dialog fullScreen open={currentMapCoords} onClose={closeMap} TransitionComponent={Transition}>
            <AppBar style={{ position: "relative" }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={closeMap} aria-label="close"><CloseIcon /></IconButton>
                    <Typography variant="h6" style={{ marginLeft: 7 }}>Parking Location</Typography>
                </Toolbar>
            </AppBar>

            {currentMapCoords &&
                <MapContainer center={currentMapCoords.coordinates} zoom={17} scrollWheelZoom={true} style={{ height: "100%" }}>
                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={currentMapCoords.coordinates}>
                        <Tooltip direction="top" offset={[-15, -15]} opacity={0.8} permanent>{currentMapCoords.label}</Tooltip>
                    </Marker>
                </MapContainer>
            }
        </Dialog>
    </div>);
};

const validateEdit = values => {
    const errors = {};
    if (values.name == null || values.name === "") {
        errors.name = 'Parking Name is Required';
    } else if (values.name.length > 200) {
        errors.name = 'Name too long';
    }

    if (values.parking_address == null || values.parking_address === "") {
        errors.parking_address = 'Address is Required';
    } else if (values.parking_address.length > 1000) {
        errors.parking_address = 'Address too long';
    }

    if (typeof values.number_of_gates === "string" && values.number_of_gates.search(/^\d*$/g) === -1) {
        errors.number_of_gates = 'Invalid Number of Gates';
    }
    if (typeof values.number_of_operators === "string" && values.number_of_operators.search(/^\d*$/g) === -1) {
        errors.number_of_operators = 'Invalid Number of Operators';
    }
    if (typeof values.number_of_shifts === "string" && values.number_of_shifts.search(/^\d*$/g) === -1) {
        errors.number_of_shifts = 'Invalid Number of Shifts';
    }
    if (typeof values.rfid_readers === "string" && values.rfid_readers.search(/^\d*$/g) === -1) {
        errors.rfid_readers = 'Invalid Number of Rfid Readers';
    }
    if (typeof values.boom_barriers === "string" && values.boom_barriers.search(/^\d*$/g) === -1) {
        errors.boom_barriers = 'Invalid Number of Boom Barriers';
    }
    for (let vehicleType in featuresJson.vehicle_type) {
        const key = `vehicle_type_${vehicleType}_capacity`;
        if (typeof values[key] === "string" && values[key].search(/^\d*$/g) === -1) {
            errors[key] = `Invalid ${featuresJson.vehicle_type[vehicleType].label} Capacity`;
        }
    }
    if (typeof values.monthly_users_count === "string" && values.monthly_users_count.search(/^\d*$/g) === -1) {
        errors.monthly_users_count = 'Invalid Monthly User Count';
    }
    return errors
};

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};
const CustomToolbar = withStyles(toolbarStyles)(props => (
    <RaToolbar {...props}>
        <SaveButton />
    </RaToolbar>
));

const FACILITIES = {
    "underground_parking": { label: "Underground Parking", value: false },
    "proper_lighting": { label: "Proper Lighting", value: false },
    "multilevel_parking": { label: "Multilevel Parking", value: false },
    "security_camera": { label: "Security Camera", value: false },
    "boom_barrier": { label: "Boom Barrier", value: false },
    "security_guard": { label: "Security Guard", value: false },
    "lift": { label: "Lift", value: false },
    "electric_charging": { label: "Electric Charging", value: false }
};
export const ParkingDetailsEdit = (props) => {
    //const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const classes = useStyles();
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    return (<>

        <Edit {...props} undoable={false} onFailure={onFailure} onSuccess={onSuccess} classes={{ noActions: classes.editNoActions }}>
            <SimpleForm redirect="list" toolbar={<CustomToolbar />} style={{ padding: "0 12px" }} validate={validateEdit} >
                <BooleanInput source="approved" label="Active" />

                <div style={{ display: "grid", gridTemplateColumns: "1fr 400px", columnGap: 20, width: "100%", margin: "10px 0 25px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <TextInput label="Parking Name" source="name" variant="outlined" style={{ maxWidth: 400 }} />
                        <RadioButtonGroupInput source="parking_type" choices={[
                            { id: 'Government', name: 'Government' },
                            { id: 'Private', name: 'Private' }
                        ]}
                        />
                        <EsperGroupSelector source="esper_group_id" />
                        <TextInput multiline={true} label="Address" source="parking_address" variant="outlined" inputProps={{ style: { height: 40 } }} />
                    </div>
                    <RaLocationInput latitudeSource="parking_latitude" longitudeSource="parking_longitude" />
                </div>

                <RaImagesInput source="parking_images" style={{ margin: "10px 0 30px" }} />

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", columnGap: 20, width: "100%" }}>
                    <TextInput variant='outlined' source="parking_latitude" />
                    <TextInput variant='outlined' source="parking_longitude" />
                    <TextInput variant='outlined' source="city" />
                    <TextInput variant='outlined' source="rfid_readers" label="Number of Rfid Readers" />
                    <TextInput variant='outlined' source="boom_barriers" label="Number of Boom Barriers" />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", columnGap: 20, width: "100%" }}>
                    <TextInput label="Number of Gates" source="number_of_gates" variant="outlined" />
                    <TextInput label="Number of Operators" source="number_of_operators" variant="outlined" />
                    <TextInput label="Number of Shifts" source="number_of_shifts" variant="outlined" />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", columnGap: 10, width: "100%" }}>
                    <TextInput label="Monthly Users Count" source="monthly_users_count" variant="outlined" />
                </div>

                <p style={{ fontWeight: "bold" }}>Timings</p>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))", columnGap: 20, width: "100%" }}>
                    {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(day => {
                        const dayKey = day.toLowerCase().substr(0, 3);
                        return (<div key={dayKey}>
                            <Typography style={{ color: "#666" }}>{day}</Typography>
                            <div style={{ display: "flex", gap: 8 }}>
                                <TimeInput variant="outlined" source={`start_time_${dayKey}`} style={{ maxWidth: 150 }} options={{ format: 'hh:mm a' }} />
                                <Typography style={{ lineHeight: "55px" }}>to</Typography>
                                <TimeInput variant="outlined" source={`end_time_${dayKey}`} style={{ maxWidth: 150 }} options={{ format: 'hh:mm a' }} />
                            </div>
                        </div>);
                    })}
                </div>

                <p style={{ fontWeight: "bold" }}>Facilities</p>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", columnGap: 10, width: "100%" }}>
                    {Object.keys(FACILITIES).map(facility => (
                        <CustomRaCheckBoxInput key={facility} source={facility} label={FACILITIES[facility].label} />
                    ))}
                </div>

                <OccupancyDetails/>

            </SimpleForm>
        </Edit>
    </>);
}

function CustomRaCheckBoxInput(props) {
    const { input: { value, onChange } } = useInput(props);
    const { source, label, style, controlProps } = props;

    const toggle = event => {
        onChange(event.target.checked === true ? 1 : 0);
    };
    return (
        <FormControlLabel
            control={<Checkbox checked={value === 1 ? true : false} {...controlProps} />}
            label={label ? label : source}
            onChange={toggle}
            style={style}
        />
    );
};

const OccupancyDetails = (props) => {
    const { input: { value: isOccupancyNotificationsEnabled } } = useInput({ ...props, id: "occupancy_notifications", source: "occupancy_notifications" });

    const { input: { onChange: setAppSection } } = useInput({ ...props, id: "occupancy_app_section", source: "occupancy_app_section" });
    const { input: { onChange: setVisitorOccupancy} } = useInput({ ...props, id: "visitor_occupancy", source: "visitor_occupancy" });
    const { input: { onChange: setPermitOccupancy } } = useInput({ ...props, id: "permit_occupancy", source: "permit_occupancy" });

    useEffect(() =>{
        if(isOccupancyNotificationsEnabled === 0){
            setAppSection(0)
            setVisitorOccupancy(0)
            setPermitOccupancy(0)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOccupancyNotificationsEnabled])

    return <div>
        <p style={{ fontWeight: "bold" }}>Occupancy Details</p>

        <div>
            <CustomRaCheckBoxInput key="occupancy_notifications" source="occupancy_notifications" label="Enable Notifications" />
        </div>
        {
            isOccupancyNotificationsEnabled === 1 &&
            <div>
                <div>
                    <CustomRaCheckBoxInput key="occupancy_app_section" source="occupancy_app_section" label="Show In App" />
                </div>
                <div>
                    <CustomRaCheckBoxInput key="visitor_occupancy" source="visitor_occupancy" label="Enable Visitor Occupancy" />
                </div>
                <div>
                    <CustomRaCheckBoxInput key="permit_occupancy" source="permit_occupancy" label="Enable Permit Occupancy" />
                </div>

                <p style={{ fontWeight: "bold" }}>Vehicles Capacity</p>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", columnGap: 10, width: "100%" }}>
                    {Object.keys(featuresJson.vehicle_type).map(vehicle_type => (
                        <TextInput
                            key={vehicle_type}
                            label={`${featuresJson.vehicle_type[vehicle_type].label} Capacity`}
                            source={`vehicle_type_${vehicle_type}_capacity`}
                            variant="outlined"
                        />
                    ))}
                </div>

                <p style={{ fontWeight: "bold" }}>Vehicles Occupancy</p>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", columnGap: 10, width: "100%" }}>
                    {Object.keys(featuresJson.vehicle_type).map(vehicle_type => (
                        <TextInput
                            key={vehicle_type}
                            label={`${featuresJson.vehicle_type[vehicle_type].label} Occupancy`}
                            source={`vehicle_type_${vehicle_type}_default_occupancy`}
                            variant="outlined"
                        />
                    ))}
                </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", columnGap: 10, width: "100%" }}>
                        <div>
                            <p style={{ fontWeight: "bold" }}>Notify Start Time</p>
                            <NotifyStartTime />
                        </div>

                        <div>
                            <p style={{ fontWeight: "bold" }}>Notify End Time</p>
                            <NotifyEndTime />
                        </div>

                        <div>
                            <p style={{ fontWeight: "bold" }}>Reset Time</p>
                            <TimeInputField />
                        </div>
                    </div>
            </div>
        }
    </div>
}

const TimeInputField = props => {
    const { input: { value: dayResetTime, onChange: setDayResetTime } } = useInput({ ...props, id: "day_reset_time", source: "day_reset_time" });
    const [helperText, setHelperText] = React.useState(null);

    const handleChange = (e) => {
        if (new RegExp("^[0-9]{2}:[0-9]{2}:[0-9]{2}$").test(e.target.value))
            setHelperText(null);
        else
            setHelperText("Input should be in the format hh:mm:ss");
        setDayResetTime(e.target.value);
    }

    const handleBlur = (e) => {
        setHelperText(null);
    }

    useEffect(() => {
        if (dayResetTime) setDayResetTime(dayResetTime)
        else setDayResetTime("00:00:00")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <MuiTextField
            variant="outlined"
            label="Day Start Time"
            value={dayResetTime}
            error={helperText != null}
            helperText={helperText}
            onChange={handleChange}
            onBlur={helperText ? handleBlur : null}
            style={{ marginBottom: 20 }}
        />
    );
}

const NotifyStartTime = props => {
    const { input: { value: time, onChange: setTime } } = useInput({ ...props, id: "notify_time_start", source: "notify_time_start" });
    const [helperText, setHelperText] = React.useState(null);

    const handleChange = (e) => {
        if (new RegExp("^[0-9]{2}:[0-9]{2}:[0-9]{2}$").test(e.target.value))
            setHelperText(null);
        else
            setHelperText("Input should be in the format hh:mm:ss");
        setTime(e.target.value);
    }

    const handleBlur = (e) => {
        setHelperText(null);
    }

    useEffect(() => {
        if (time) setTime(time)
        else setTime("00:00:00")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <MuiTextField
            variant="outlined"
            label="Notify Start Time"
            value={time}
            error={helperText != null}
            helperText={helperText}
            onChange={handleChange}
            onBlur={helperText ? handleBlur : null}
            style={{ marginBottom: 20 }}
        />
    );
}

const NotifyEndTime = props => {
    const { input: { value: time, onChange: setTime } } = useInput({ ...props, id: "notify_time_end", source: "notify_time_end" });
    const [helperText, setHelperText] = React.useState(null);

    const handleChange = (e) => {
        if (new RegExp("^[0-9]{2}:[0-9]{2}:[0-9]{2}$").test(e.target.value))
            setHelperText(null);
        else
            setHelperText("Input should be in the format hh:mm:ss");
        setTime(e.target.value);
    }

    const handleBlur = (e) => {
        setHelperText(null);
    }

    useEffect(() => {
        if (time) setTime(time)
        else setTime("00:00:00")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <MuiTextField
            variant="outlined"
            label="Notify End Time"
            value={time}
            error={helperText != null}
            helperText={helperText}
            onChange={handleChange}
            onBlur={helperText ? handleBlur : null}
            style={{ marginBottom: 20 }}
        />
    );
}